var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtractASmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 56,
    viewBox: "0 0 21 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2976 0H11.9306H11.7952L11.6719 0.055824L0.368918 5.17049L0 5.33743V5.74236V11.8447V12.7633L0.855809 12.4295L11.303 8.35411V55.3723V56H11.9306H14.2976V55.3723H12.5583H11.9306V54.7446V8.10926V7.4355L11.303 7.68035L1.25539 11.5998L0.627693 11.8447V11.1709V5.74236L11.9306 0.627693H14.2976V0Z",
    fill: "#D9D9DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractASmall);
export default __webpack_public_path__ + "static/media/subtract-a-small.c02e1139a173c131b991fd637f42046f.svg";
export { ForwardRef as ReactComponent };